import { render } from "./DescriptionProgramsTable.vue?vue&type=template&id=ff273f02&scoped=true"
import script from "./DescriptionProgramsTable.vue?vue&type=script&lang=js"
export * from "./DescriptionProgramsTable.vue?vue&type=script&lang=js"

import "./DescriptionProgramsTable.vue?vue&type=style&index=0&id=ff273f02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff273f02"]])

export default __exports__